import { cn } from "../../../Utils/helper";

export default function Button({
  text,
  icon,
  iconMoon,
  onClick,
  iconRight,
  maxWidth,
  className,
  iconSub,
  iconName,
  iconColor,
  disabled = false,
}) {
  return (
    <div
      className={cn(
        "flex items-center px-4 mt-2.5 w-full",
        maxWidth ? `max-w-${maxWidth}` : "w-full",
        "border border-solid min-h-[42px]",
        className,
        disabled && "opacity-50 cursor-not-allowed"
      )}
      role="button"
      tabIndex={0}
      onClick={!disabled ? onClick : undefined}
      onKeyPress={(e) => {
        if (!disabled && e.key === "Enter") onClick();
      }}
    >
      {icon && (
        <img
          loading="lazy"
          src={icon}
          alt=""
          className="object-contain shrink-0 self-stretch my-auto w-5 aspect-square"
        />
      )}
      <div
        className={`flex gap-2 items-center justify-center m-auto font-[Figtree]`}
      >
        {iconSub && (
          <img
            loading="lazy"
            src={iconSub}
            alt=""
            className="object-contain shrink-0 self-stretch my-auto w-6 aspect-square  "
          />
        )}
        {iconName && (
          <span
            className={`icon icon-${iconName} text-[${iconColor}] text-xl `}
          />
        )}
      {iconMoon && iconMoon}

        {text}
      </div>

      {iconRight ? (
        <img
          loading="lazy"
          src={iconRight}
          alt=""
          className="object-contain shrink-0 self-stretch my-auto w-5 aspect-square"
        />
      ) : (
        <div></div>
      )}
    </div>
  );
}
